import * as React from 'react';

import { AgreementsBlock } from './components';
import { useApplicationContext } from '../../utils/applicationContext';

interface IAgreementBlockContainer {
  isChecked?: boolean;
  toggleCheckbox(): void;
  buttonText: string;
}
export const AgreementBlockContainer: React.FC<IAgreementBlockContainer> = ({
  isChecked,
  toggleCheckbox,
  buttonText,
}) => {
  const { config } = useApplicationContext();
  const marketingAgreementUrl = config.get<string>('cpl.marketingAgreementUrl') || '';
  const personalDataAgreement = config.getStrict<string>('cpl.personalDataAgreement');
  const privacyPolicyUrl = config.getStrict<string>('privacyPolicyUrl');

  return (
    <AgreementsBlock
      isChecked={isChecked}
      toggleCheckbox={toggleCheckbox}
      marketingAgreementUrl={marketingAgreementUrl}
      personalDataAgreement={personalDataAgreement}
      privacyPolicyUrl={privacyPolicyUrl}
      buttonText={buttonText}
    />
  );
};
